import { render, staticRenderFns } from "./PaypalCheckout.vue?vue&type=template&id=840b1566&scoped=true"
import script from "./PaypalCheckout.vue?vue&type=script&lang=js"
export * from "./PaypalCheckout.vue?vue&type=script&lang=js"
import style0 from "./PaypalCheckout.vue?vue&type=style&index=0&id=840b1566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840b1566",
  null
  
)

export default component.exports